import { createSelector } from 'reselect';
import ReportByCreativeComponent from '../../../../utils/ReportByCreativeComponent/ReportByCreativeComponent';

const location = (state) => state.routing?.location || state.routing?.locationBeforeTransitions || {};
const report = (state) => state.serverStorage.store.reportByCreative || state.serverStorage.store.report;
const reportUtils = ReportByCreativeComponent.utils;

export const getCheckedKeys = createSelector(
    location,
    report,
    (location, report) => {
        let metrics = (location.query && location.query.metrics) || (report && report.metrics) || reportUtils.getDefStrMetric();
        let keysMetric = reportUtils.getKeysMetric(metrics);

        return keysMetric;
    }
);

export const getMetrics = createSelector(
    location,
    report,
    (location, report) => {
        return (location.query && location.query.metrics) || (report && report.metrics) || reportUtils.getDefStrMetric();
    }
);

export const mainSelector = createSelector(
    report,
    (report) => {
        return reportUtils.getMultiLevelHeaderNames();
    }
);
